import React from 'react'

const AddNoteModalContent = ({row}) => {
  return (
    <div>AddNoteModalContent</div>
  )
}

export default AddNoteModalContent